const O_LEVEL_COMPLETION_STATUSES = Object.freeze([
  "submitted",
  "admission_offered",
  "enrolled",
]);

const canCompleteOutstandingOLevel = (application) =>
  application?.oLevelResultStatus === "awaiting_result" &&
  O_LEVEL_COMPLETION_STATUSES.includes(application?.status);

export { O_LEVEL_COMPLETION_STATUSES, canCompleteOutstandingOLevel };
